<template>
  <section class="form__item__input">
    <select-input :selectClass="selectClass" v-model="value" :options="selectOptions" :defaultValue="value" style="min-width: 185px;"/>
    <div v-if="value && value.type == 'custom'" style="text-align: right;width:500px">
      <div style="display:inline-block; padding-right: 1em; padding-top:1em;">
        <input type="number" :placeholder="value.width" class="input__field" style="width: 85%" v-model="width" />
        <span style="display:inline-block;padding-top:10px">px</span>
      </div>
      <div style="display:inline-block;">
        <input type="number" :placeholder="value.height" class="input__field" style="width: 85%" v-model="height" />
        <span style="display:inline-block;padding-top:10px;">px</span>
      </div>
    </div>
  </section>
</template>

<script>
import SelectInput from './SelectInput.vue'

export default {
  name: 'SizeInput',
  components: {
    SelectInput,
  },
  props: ['defaultValue', 'options', 'selectClass'],
  methods: {
    update(value){
      this.$emit('input', value);
    }
  },
  data(){
    let selectOptions = this.options ? this.options.map((item)=>{
      var label = "";
      if(item.type == 'fixed'){
        label = "Fixed (" + item.width+"x"+item.height + ")";
      } else if (item.type == 'flexible'){
        label = "Flexible (" + item.width+":"+item.height + ")";
      } else if(item.type == 'dynamic'){
        label = "Dynamic";
      } else if(item.type == 'custom'){
        label = "Custom";
        //if(this.defaultValue) item = this.defaultValue;
      } else if(item.type == 'none'){
        label = "None";
      }

      return { label, value: item}
    }) : []

    let value = this.defaultValue || selectOptions[0].value ||  {};

    return {
      value,
      selectOptions,
      height: value.height,
      width: value.width
    }
  },
  watch: {
    value(newVal){
      this.update(newVal);
    },
    height(newVal){
      this.value.height = Number(newVal);
      this.update(this.value);
    },
    width(newVal){
      this.value.width = Number(newVal);
      this.update(this.value);
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/configurator/SizeInput.vue